import i18next from 'i18next';

i18next.addResources('es', 'CourseItemHighlightShowcase', {
  startCourse: 'Iniciar curso'
});

i18next.addResources('en-US', 'CourseItemHighlightShowcase', {
  startCourse: 'Start course'
});
